var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a-row',{attrs:{"gutter":[8,8]}},[_vm._l((_vm.statistics),function(statistic,i){return [_c('a-col',{key:i,attrs:{"xs":24,"md":_vm.colMd}},[_c('card-statistic',{attrs:{"icon":'team',"data":statistic}})],1)]})],2)}
var staticRenderFns = []

export { render, staticRenderFns }